import { useState } from "react";
import { FileText, AppWindow, Package, Braces, Loader2, BookOpenCheck } from "lucide-react";
import { toast } from "sonner";
import { downloadFile, errMsg } from "@/lib/api";

const ITEMS = [
  { kind: "pdf", title: "PDF guide", desc: "Typeset A5 pocket guide", icon: FileText },
  { kind: "app", title: "Offline toolkit", desc: "Interactive single-file HTML app", icon: AppWindow },
  { kind: "package", title: "Store package", desc: "ZIP: PDF + app + listing", icon: Package },
  { kind: "listing", title: "Listing JSON", desc: "Product copy for the site", icon: Braces },
  { kind: "sample", title: "Free sample", desc: "Cover + Chapter I, watermarked", icon: BookOpenCheck },
];

export const DownloadHub = ({ guideId }) => {
  const [busy, setBusy] = useState(null);
  const go = async (kind) => {
    setBusy(kind);
    try {
      await downloadFile(guideId, kind);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(null);
    }
  };
  return (
    <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-px bg-[#E2D9CC] border border-[#E2D9CC]" data-testid="download-hub">
      {ITEMS.map(({ kind, title, desc, icon: Icon }, i) => (
        <button key={kind} data-testid={`download-${kind}-button`} onClick={() => go(kind)} disabled={!!busy}
          className={`text-left p-7 transition-colors duration-200 group ${i === 0 ? "bg-[var(--g-dark,#3B1B48)] text-[#FAF7F2] hover:bg-[var(--g-dark2,#4A1E5C)]" : "bg-[#FAF7F2] hover:bg-[var(--g-mist,#EFE6F3)]"}`}>
          {busy === kind ? <Loader2 className="w-6 h-6 animate-spin text-[var(--g-accent,#C59B27)]" /> : <Icon className="w-6 h-6 text-[var(--g-accent,#C59B27)]" strokeWidth={1.4} />}
          <p className={`font-display text-xl mt-5 ${i === 0 ? "" : "text-[var(--g-dark,#3B1B48)]"}`}>{title}</p>
          <p className={`text-xs mt-1 ${i === 0 ? "text-[var(--g-mist,#EFE6F3)]" : "text-[#8C827A]"}`}>{desc}</p>
          <p className="eyebrow mt-5 group-hover:translate-x-1 transition-transform">Download →</p>
        </button>
      ))}
    </div>
  );
};
